import React from "react";
import { Depths, mergeStyleSets, Stack, Text, useTheme } from "@fluentui/react";
import { ITestResultWrapper } from "../TestResultPage";
import MtaStsValidationResultItem from "./MtaStsValidationResultItem";
import { Utils } from "../../Utils";
import { IRcaMtaStsValidationTestResult } from "../../models/IRcaMtaStsValidationTestResult";

/**
 * The test result page component
 *
 * @param props - The component properties
 * @returns The markup
 */
export const MtaStsValidationResultPage: React.FC<ITestResultWrapper> = ({ currentResult }) => {
  const theme = useTheme();
  const classNames = mergeStyleSets({
    root: {
      width: "100%",
      padding: 20,
    },
    titleBlock: {
      width: "100%",
      backgroundColor: `var(--rca-card-background, ${theme.semanticColors.bodyBackground})`,
      border: "1px solid var(--rca-card-border, transparent)",
      borderRadius: 2,
      boxShadow: `var(--rca-card-shadow, ${Depths.depth4})`,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 12,
      paddingBottom: 12,
      marginBottom: 20,
      selectors: {
        [Utils.mobileQuery]: {
          flexDirection: "column",
          alignItems: "flex-start",
          "& > span": {
            [Utils.mobileQuery]: {
              paddingBottom: 20,
            },
          },
        },
      },
    },
  });

  let result: IRcaMtaStsValidationTestResult | null = null;
  let isValidResult = true;

  try {
    result = currentResult.AdditionalResultData as IRcaMtaStsValidationTestResult;
  } catch {
    isValidResult = false;
  }

  return (
    <Stack className={classNames.root}>
      <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className={classNames.titleBlock}>
        <Text variant="xLarge" block>
          {currentResult.ResultDescription}
        </Text>
      </Stack>
      {result &&
        result.Domains.map((domainResult) => <MtaStsValidationResultItem key={domainResult.Domain?.Value} result={domainResult} />)}
      {!isValidResult && (
        <>
          <Stack>{currentResult.TestDescription}</Stack>
          <Stack>{currentResult.ResultDescription}</Stack>
        </>
      )}
    </Stack>
  );
};

export default MtaStsValidationResultPage;
